import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {PoStorageService} from '@po-ui/ng-storage';
import {AuthService} from '../service/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  attempts = 3;
  loading: boolean;
  loginErrors = [];
  passwordErrors = [];
  showPageBlocked: boolean;

  constructor(
    private authService: AuthService,
    private router: Router,
    private poStorageService: PoStorageService,
  ) {
    this.loading = false;
    this.showPageBlocked = false;
  }

  ngOnInit(): void {
  }

  checkLogin(formData: any): void {
    this.loading = true;

    this.authService.login(formData.login, formData.password).subscribe(
      token => {
        this.passwordErrors = [];
        this.loginErrors = [];
        localStorage.setItem('token', JSON.stringify({...token, last_token_refresh: new Date().getTime() / 1000}));
        this.authService.getUser().subscribe(usuario => {
          this.poStorageService.set('usuario', usuario);
          if (usuario.AEMPRESA) {
            localStorage.setItem('empresaSelecionada', JSON.stringify(usuario.AEMPRESA[0]));
            this.poStorageService.get('redirectUrl').then(url => this.router.navigateByUrl(url));
            localStorage.setItem('CUSRID', usuario.CUSRID);
            const {CM0CODIGO, CM0CODFIL} = usuario.AEMPRESA[0];
            localStorage.setItem('tenantid', `${CM0CODIGO},${CM0CODFIL}`);
          }
        });
      }, error => {
        this.loading = false;
        // @ts-ignore
        this.passwordErrors = ['Senha e/ou usuário inválido, verifique e tente novamente.'];
      });
  }

  loginChange(): void {
    if (this.passwordErrors.length) {
      this.passwordErrors = [];
      this.loginErrors = [];
    }
  }

}
